import { render } from "./discuss.vue?vue&type=template&id=a9723e5a&scoped=true"
import script from "./discuss.vue?vue&type=script&lang=js"
export * from "./discuss.vue?vue&type=script&lang=js"

import "./discuss.vue?vue&type=style&index=0&id=a9723e5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9723e5a"]])

export default __exports__